var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocumentIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Document Icons") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Document-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4948996,15.8907341 C15.4948996,16.8149877 14.742719,17.5672454 13.8185601,17.5672454 L5.67669856,17.5672454 C4.75218062,17.5672454 4,16.8149877 4,15.8907341 L4,3.67687032 C4,2.75225767 4.75218062,2 5.67669856,2 L7.70991996,2 L9.36651249,2 L9.36651249,5.73399882 C9.36651249,7.05466885 10.4403894,8.12865581 11.7605652,8.12865581 L15.4945405,8.12865581 L15.4945405,14.9302142 L15.4948996,15.8907341 L15.4948996,15.8907341 Z M14.9872225,7.41051006 L11.7609242,7.41051006 C10.8367653,7.41051006 10.0849437,6.65861147 10.0849437,5.73399882 L10.0849437,2.50772904 L14.9872225,7.41051006 Z",
    id: "Shape",
    fill: "#505F79",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentIcon);
export default __webpack_public_path__ + "static/media/document_icon.b1e72f64d6847ab888df26e01ae39536.svg";
export { ForwardRef as ReactComponent };